module.exports = __webpack_public_path__ + "static/media/GroundingTechniques.9e587e73.png";